var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var TodoHeader = /** @class */ (function (_super) {
    __extends(TodoHeader, _super);
    function TodoHeader(props) {
        var _this = _super.call(this, props) || this;
        _this._onFilter = function (evt) {
            _this.props.setFilter(evt.target.innerText);
        };
        _this._onChange = function (evt) {
            _this.setState({ labelInput: evt.target.value });
        };
        _this._onAdd = function () {
            _this.props.addTodo(_this.state.labelInput);
            _this.setState({ labelInput: '' });
        };
        _this.state = { labelInput: '' };
        return _this;
    }
    TodoHeader.prototype.render = function () {
        var _a = this.props, filter = _a.filter, setFilter = _a.setFilter;
        return (React.createElement("header", null,
            React.createElement("h1", null,
                "todos ",
                React.createElement("small", null, "(1.7 final)")),
            React.createElement("div", { className: "addTodo" },
                React.createElement("input", { value: this.state.labelInput, onChange: this._onChange, className: "textfield", placeholder: "add todo" }),
                React.createElement("button", { onClick: this._onAdd, className: "submit" }, "Add")),
            React.createElement("nav", { className: "filter" },
                React.createElement("button", { onClick: this._onFilter, className: filter === 'all' ? 'selected' : '' }, "all"),
                React.createElement("button", { onClick: this._onFilter, className: filter === 'active' ? 'selected' : '' }, "active"),
                React.createElement("button", { onClick: this._onFilter, className: filter === 'completed' ? 'selected' : '' }, "completed"))));
    };
    return TodoHeader;
}(React.Component));
export { TodoHeader };
